import * as angular from "angular";
import {RoutesViewSettingsModel} from "../models/routes-view-settings.model";
import {ROUTE_META_DATA_UPDATED_EVENT} from "./routes-events.constant";

const defaultViewSettings: RoutesViewSettingsModel = {
  services: {
    columns: {
      id: true,
      contact: true,
      route: true,
      account: true,
      timeWindow: true,
      location: true,
      serviceTime: false,
      packages: true,
      tags: false,
      skills: false,
      price: false,
      proNumber: false,
      resource: false,
      relations: true
    },
    load: {
      weight: false,
      volume: false,
      packages: false,
      value: false,
      spots: false,
      pallets: false
    }
  },
  routes: {
    columns: {
      id: false,
      status: true,
      skills: true,
      resource: true,
      agent: false,
      assistant: false,
      price: false,
      timeWindow: true,
      duration: false,
      distance: false,
      services: true,
      tasksCount: false,
      accounts: false,
      accountsExternalIds: false,
      plateNumber: true,
      trips: false,
      tags: false,
      pickingHour: false,
      proNumber: false,
      referenceIds: false,
      pickupStops: false,
      destinationStops: false,
      progress: false,
      relations: false
    },
    metadata: [],
    load: {
      weight: false,
      volume: false,
      packages: false,
      value: false,
      spots: false,
      pallets: false
    },
    capacity: {
      weight: false,
      volume: false,
      pallets: false
    }
  },
  route: {
    columns: {
      id: true,
      status: true,
      account: true,
      serviceType: true,
      timeWindow: true,
      address: true,
      serviceTime: true,
      sla: false,
      packages: true,
      labels: false,
      price: true,
      eta: true,
      etd: true,
      relations: true,
      proNumber: false,
      contact: false,
      programType: false,
      depotExternalId: false
    },
    load: {
      weight: false,
      volume: false,
      packages: false,
      value: false,
      spots: false,
      pallets: false
    },
    capacity: {
      weight: false,
      volume: false,
      pallets: false,
    }
  },
  resources: {
    columns: {
      timeWindow: true,
      totalDuration: false,
      tags: true,
      labels: true,
      routesCount: true,
      routeNames: false,
      vehicleType: true,
      logisticVehicles: false,
      retrips: false
    },
    load: {
      weight: false,
      volume: false,
      packages: false,
      value: false,
      spots: false,
      pallets: false
    },
    capacity: {
      weight: false,
      volume: false,
      pallets: false,
    }
  },
}

angular
  .module('bringoz.admin.routes')
  .constant('routesConstants', {
    defaultViewSettings: defaultViewSettings,
    events: {
      routeMetaDataUpdated: ROUTE_META_DATA_UPDATED_EVENT
    }
  });
